import { ArticleParameterComparison } from "../../models/articleCompare"
import { ArticleParameter } from "../../models/article"

export const compareParamsProcessor = (paramsComparison: ArticleParameterComparison[]) => {
    return paramsComparison.reduce<ArticleParameter[]>((accum, comparison) => {
        const newParameter: ArticleParameter = {
            SlotId: comparison.SlotId.Value,
            Value: comparison.Value.Value,
            SlotIdComparison: comparison.SlotId.ComparisonType,
            ValueComparison: comparison.Value.ComparisonType
        }
        accum.push(newParameter)
        return accum
    }, [])
}
